import { isPublic } from '@core/router/utils';
import { Auth } from '@core/auth';

import Investor from '@/models/Investor';

const redirectRestrictedInvestor = async (to, from, next) => {
    if (isPublic(to)) {
        next();
    } else {
        const auth = Auth();

        if (auth.is_initialised && auth.is_investor) {
            const investor = await Investor.$get(auth.organisation_id);

            if (
                investor.is_portfolio_restricted &&
                (to.path.startsWith('/portfolio') ||
                    to.path.startsWith('/accounts') ||
                    to.path.startsWith('/transactions') ||
                    (to.path !== '/reports' && to.path.startsWith('/reports') && !to.path.includes('activity')))
            ) {
                next({
                    name: 'InvestorPortfolioRestrictedNotice',
                    query: { redirect_page: to.meta.heading || null, redirect_path: to.path }
                });
            } else {
                next();
            }
        } else {
            next();
        }
    }
};

export default redirectRestrictedInvestor;
